module.exports = __webpack_public_path__ + "static/img/Cosmetics.1135d7b.png";